import { render, staticRenderFns } from "./Benchmark.vue?vue&type=template&id=7665bd3d&scoped=true&"
import script from "./Benchmark.vue?vue&type=script&lang=js&"
export * from "./Benchmark.vue?vue&type=script&lang=js&"
import style0 from "./Benchmark.vue?vue&type=style&index=0&id=7665bd3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7665bd3d",
  null
  
)

export default component.exports